<mat-card appearance="outlined" class="special-features__subsection subsection">
  <div class="subsection__header">
    <span
      class="subsection__header-item header-item"
      [ngClass]="{
        'header-item--active': isActive,
        'header-item--inactive': !isActive,
      }">
      <mat-icon id="circle">circle</mat-icon>
    </span>
    <span class="subsection__header-item header-item"><h4>Custom label is</h4></span>
    <span
      class="subsection__header-item header-item"
      [ngClass]="{
        'header-item--active': isActive,
        'header-item--inactive': !isActive,
      }"
      ><h4>{{ isActive ? 'active' : 'inactive' }}</h4></span
    >
    <span class="subsection__header-item subsection__toggle header-item">
      <mat-slide-toggle
        [disabled]="true"
        (toggleChange)="onIsSpecialLabelActiveChange()"
        [checked]="isActive"
        color="primary"></mat-slide-toggle>
    </span>
  </div>
  <div class="subsection__checkboxes">
    <mat-checkbox
      (change)="onHasReturnNoteChange()"
      [checked]="options.hasReturnNode"
      [disabled]="true"
      color="primary"
      class="subsection__checkbox"
      >פתק החלפה</mat-checkbox
    >
    <mat-checkbox
      (change)="onHasNoItemsChange()"
      [checked]="options.hasNoItems"
      [disabled]="true"
      color="primary"
      class="subsection__checkbox"
      >בלי פריטים</mat-checkbox
    >
    <mat-checkbox
      (change)="onHasGovinaChange()"
      [checked]="options.hasGovina"
      [disabled]="true"
      color="primary"
      class="subsection__checkbox"
      >גובינא</mat-checkbox
    >
    <mat-checkbox
      (change)="onHasNoteChange()"
      [checked]="options.hasNote"
      [disabled]="true"
      color="primary"
      class="subsection__checkbox"
      >הערה</mat-checkbox
    >
    <mat-checkbox
      (change)="onHasGreetingCardChange()"
      [checked]="options.hasGreetingCard"
      [disabled]="true"
      color="primary"
      class="subsection__checkbox"
      >ברכה</mat-checkbox
    >
  </div>
</mat-card>
